import { render, staticRenderFns } from "./Umsatzanzeige.vue?vue&type=template&id=55de05a0&scoped=true&"
import script from "./Umsatzanzeige.vue?vue&type=script&lang=js&"
export * from "./Umsatzanzeige.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55de05a0",
  null
  
)

export default component.exports